export function initAnalyticsTracking() {
  // ahoy tracking js events
  $("#help_center_link").click(function (e) {
    ahoy.track("Help center link clicked", e.target.dataset);
  });

  $("#referral_link").click(function (e) {
    ahoy.track("Referral link copied", e.target.dataset);
  });

  $("#referral_share_email").click(function (e) {
    ahoy.track("Share referral button clicked", { channel: "email" });
  });

  $("#referral_share_facebook").click(function (e) {
    e.preventDefault(); // necessary because this was reloading the page
    ahoy.track("Share referral button clicked", { channel: "facebook" });
  });

  $("#referral_share_linkedin").click(function (e) {
    e.preventDefault(); // necessary because this was reloading the page
    ahoy.track("Share referral button clicked", { channel: "linkedin" });
  });

  $("#donation_link").click(function (e) {
    ahoy.track("Site donation button clicked");
  });
}
